
seedWebControllers.controller('ScopeEditValuesController', ['$scope', 'scopeItem', 'propertyToRead', '$uibModalInstance', '$timeout', 'translation',
    function ($scope, scopeItem, propertyToRead, $uibModalInstance, $timeout, translation) {

        $scope.scopeItem = scopeItem;
        $scope.propertyToRead = propertyToRead;
        $scope.translation = translation;

        $scope.save = function () {

            console.log('SCOPEEDITVALUES [' + $scope.scopeItem.ScopeValues + ']');


            $uibModalInstance.close($scope.scopeItem);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.codemirrorRefresh = 0;

        $scope.codemirrorReload = function () {
            $timeout(function () {
                $scope.codemirrorRefresh += 1;
            }, 200);
        };


    }
]);